export default "__VITE_ASSET__DSC80dxL__"